'use client';

export const OPEN_WORKSPACE_ARTIFACT_EVENT = 'imai:open-workspace-artifact';
export const COLLAPSE_THREAD_SIDEBAR_EVENT = 'imai:collapse-thread-sidebar';
export const THREAD_SIDEBAR_COLLAPSED_STORAGE_KEY = 'thread-sidebar-collapsed';

export type OpenWorkspaceArtifactDetail = {
  path: string;
  openPaths?: string[];
  orgThreadId?: string;
  threadRef?: string;
  panelTargetId?: string;
  displayMode?: 'panel' | 'expanded' | 'fullscreen';
  source?: 'auto' | 'user';
};

export type ThreadSidebarCollapseDetail = {
  reason?: 'agent-artifact-open' | 'artifact-open';
};

export function requestThreadSidebarCollapse(
  detail?: ThreadSidebarCollapseDetail
): void {
  if (typeof window === 'undefined') return;
  try {
    if (
      detail?.reason !== 'agent-artifact-open' &&
      detail?.reason !== 'artifact-open' &&
      window.localStorage?.getItem(THREAD_SIDEBAR_COLLAPSED_STORAGE_KEY) === '0'
    )
      return;
  } catch {
    // Automatic layout changes must never overwrite a saved user preference.
  }
  window.dispatchEvent(
    new CustomEvent(COLLAPSE_THREAD_SIDEBAR_EVENT, { detail })
  );
}

/** Artifact opens collapse the sidebar without changing its saved preference. */
export function requestArtifactPanelSidebarCollapse({
  source,
  currentPath,
  nextPath,
}: {
  source?: 'auto' | 'user';
  currentPath: string | null;
  nextPath: string;
}): void {
  if (source === 'auto') {
    if (currentPath !== nextPath) {
      requestThreadSidebarCollapse({ reason: 'agent-artifact-open' });
    }
    return;
  }
  requestThreadSidebarCollapse({ reason: 'artifact-open' });
}

export function openWorkspaceArtifactInThread(
  path: string,
  options?: {
    orgThreadId?: string | null;
    threadRef?: string | null;
    panelTargetId?: string | null;
    displayMode?: 'panel' | 'expanded' | 'fullscreen' | null;
    source?: 'auto' | 'user' | null;
    openPaths?: string[] | null;
  }
): void {
  window.dispatchEvent(
    new CustomEvent<OpenWorkspaceArtifactDetail>(
      OPEN_WORKSPACE_ARTIFACT_EVENT,
      {
        detail: {
          path,
          ...(options?.openPaths && options.openPaths.length > 0
            ? { openPaths: options.openPaths }
            : {}),
          ...(options?.orgThreadId ? { orgThreadId: options.orgThreadId } : {}),
          ...(options?.threadRef ? { threadRef: options.threadRef } : {}),
          ...(options?.panelTargetId
            ? { panelTargetId: options.panelTargetId }
            : {}),
          ...(options?.displayMode ? { displayMode: options.displayMode } : {}),
          ...(options?.source ? { source: options.source } : {}),
        },
      }
    )
  );
}
